import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { AppTranslateModule } from '@core/app-translate.module';
import { FormErrorModule } from '@feature/forms/form-error/form-error.module';

import { FormDatePickerComponent } from './form-date-picker.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

export const imports: NgModule['imports'] = [
  FormErrorModule,
  FormsModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatNativeDateModule,
  MatSelectModule,
  ReactiveFormsModule,
];

@NgModule({
  declarations: [FormDatePickerComponent],
  imports: [...imports, AppTranslateModule, CommonModule],
  exports: [FormDatePickerComponent],
})
export class FormDatePickerModule {}
